import { Analytics, getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useCreateAnalytics = () => {
  return useMemo(() => {
    if (
      !process.env.REACT_APP_FB_APIKEY ||
      !process.env.REACT_APP_FB_DOMAIN ||
      !process.env.REACT_APP_FB_MESSENDID ||
      !process.env.REACT_APP_FB_APPID
    ) {
      return null;
    }
    const firebaseConfig = {
      apiKey: process.env.REACT_APP_FB_APIKEY,
      authDomain: `${process.env.REACT_APP_FB_DOMAIN}.firebaseapp.com`,
      projectId: process.env.REACT_APP_FB_DOMAIN,
      storageBucket: `${process.env.REACT_APP_FB_DOMAIN}.appspot.com`,
      messagingSenderId: process.env.REACT_APP_FB_MESSENDID,
      appId: process.env.REACT_APP_FB_APPID,
    };

    const app = initializeApp(firebaseConfig);
    return getAnalytics(app);
  }, []);
};
export const AnalyticsContext = React.createContext<Analytics | null>(null);

export const useAnalytics = () => {
  return useContext(AnalyticsContext);
};

export const useAnalyticsScreenView = () => {
  const location = useLocation();
  const analytics = useAnalytics();
  useEffect(() => {
    if (analytics) {
      logEvent(analytics, "page_view", {
        page_location: location.pathname,
        origin: window.origin,
      });
    } else {
      console.log("page_view");
    }
  }, [location.pathname, analytics]);
};

type AnalyticsEvent =
  | "page_view"
  | "create_dao"
  | "create_proposal"
  | "execute_proposal"
  | "vote_proposal";

export const sendAnalyticsEvent = (
  analytics: Analytics,
  eventKind: AnalyticsEvent
) => {
  logEvent(analytics, String(eventKind));
  console.log(analytics, eventKind);
};

export const useSendFBAnalyticsEvent = () => {
  const location = useLocation();
  const analytics = useAnalytics();

  return useCallback(
    (eventKind: AnalyticsEvent) => {
      if (analytics) {
        logEvent(analytics, String(eventKind), {
          page_location: location.pathname,
          origin: window.origin,
        });
      }
    },
    [analytics, location.pathname]
  );
};
